var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),(_vm.dataIsLoading)?_c('div',{staticClass:"loadingAnimation"}):_vm._t("default",function(){return [_vm._v(" - ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }